import styled from 'styled-components'

export const RequestHistoryItem = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    color: #000;
    padding: 10px 20px;
    border-radius: 5px;
    margin-bottom: 10px;

    background-color: ${props => props.$backgroundcolor};

    ${props => props.$isactiverequest.toLowerCase() === 'false' && `
        &:hover {
            cursor: pointer;
            background-color: #eee;
        }
    `}
`

export const Timestamp = styled.div`
    color: ${({ status }) => status?.toLowerCase().includes('error') ? 'rgb(255, 0, 0)' : '#7BAD7E'};
    font-size: .8rem;
    font-weight: bold;
`

export const Title = styled.div`
    color: ${props => props.color || '#000'};
    font-weight: bold;
`
export const RequestType = styled.div``

export const RequestStatus = styled.div`
    text-transform: capitalize;
    font-weight: bold;
`

export const RequestDetailsContainer = styled.div`
    margin: 10px 0;
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    padding: 10px;
    gap: 5px;
    background-color: ${props => props.$bgColor };
`

export const DetailsMetric = styled.span`
    font-weight: bold;
    font-size: .7rem;
    color: ${props => props.color};
`

export const DetailsValue = styled.span`
    font-size: .7rem;
    font-weight: ${props => props.fontWeight || 'bold'};
    color: ${props => props.color};
`
